import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ThreatType } from '../../../../models/threat-type';

@Component({
  selector: 'lib-upsert-threat-type-modal',
  templateUrl: './upsert-threat-type-modal.component.html',
  styleUrls: ['./upsert-threat-type-modal.component.scss']
})
export class UpsertThreatTypeModalComponent implements OnInit {
  public threatType: ThreatType;
  public maxNameLength = 50;
  public submitted = false;
  public threatTypeCtrl = new FormControl('', Validators.required);

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.threatType = this.dynamicDialogConfig?.data?.threatType || new ThreatType();
  }

  ngOnInit(): void {
    console.log('todo');
  }

  save(): void {
    this.submitted = true;

    // validation
    if (!this.isValid()) {
      this.threatTypeCtrl.markAllAsTouched();
      this.threatTypeCtrl.markAsDirty();
      return;
    }

    this.dynamicDialogRef.close(this.threatType);
  }

  cancel(): void {
    this.dynamicDialogRef.destroy();
  }

  isValid(): boolean {
    let isValid = true;

    if (!this.threatType.name ||
      this.threatType.name.length > this.maxNameLength) {
      isValid = false;
    }

    return isValid;
  }
}
